"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Separator } from "@/components/ui/separator";
import { MapPin, Phone, Mail, Shield, Linkedin, Twitter, Facebook } from "lucide-react";
const address = "89 Bethany Rd, Framingham, MA 01702";
const phone = "(774) 540-0459";
const email = "Ericcampos124@gmail.com";
const businessName = "Campos V Landscaping";
const socialLinks = [{
  icon: Linkedin,
  href: "#",
  label: "LinkedIn"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Facebook,
  href: "#",
  label: "Facebook"
}];
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <div key={i} data-index={i} className="h-4 w-24 animate-pulse rounded-md bg-muted" />)}
      </div>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/OurCraftPage" className="text-sm text-muted-foreground transition-colors hover:text-primary">
            Our Craft
          </Link>
        </li>
        <li data-index={1}>
          <Link to="/SeasonalCarePage" className="text-sm text-muted-foreground transition-colors hover:text-primary">
            Seasonal Care
          </Link>
        </li>
        <li data-index={2}>
          <Link to="/GetAQuotePage" className="text-sm text-muted-foreground transition-colors hover:text-primary">
            Get a Quote
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground transition-colors hover:text-primary">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  return <section data-section-id="252329" id="footer" className="dark bg-background text-foreground py-16 lg:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-2 lg:grid-cols-4 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block text-primary transition-opacity hover:opacity-90">
              <WvcLogo className="h-8 w-auto" />
            </Link>
            <div className="flex items-start gap-3 text-muted-foreground">
              <MapPin className="mt-0.5 size-5 shrink-0 text-primary/70" />
              <p className="text-sm leading-relaxed font-default">{address}</p>
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default mb-6 text-lg font-semibold text-primary">Quick Links</h3>
            <MenuProvider menu_id="17">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default mb-6 text-lg font-semibold text-primary">Contact Us</h3>
            <ul className="flex flex-col gap-4">
              <li data-index={0} className="flex items-center gap-3">
                <Phone className="size-4 shrink-0 text-primary/70" />
                <Link to={`tel:${phone.replace(/[^0-9+]/g, '')}`} className="text-sm text-muted-foreground transition-colors hover:text-primary font-default">
                  {phone}
                </Link>
              </li>
              <li data-index={1} className="flex items-center gap-3">
                <Mail className="size-4 shrink-0 text-primary/70" />
                <Link to={`mailto:${email}`} className="text-sm text-muted-foreground transition-colors hover:text-primary font-default">
                  {email}
                </Link>
              </li>
              <li data-index={2} className="mt-2 rounded-lg border border-primary/20 bg-primary/5 p-3 shadow-md">
                <div className="mb-1 flex items-center gap-2 text-primary">
                  <Shield className="size-4" />
                  <span className="font-default text-sm font-medium">Free Consultation</span>
                </div>
                <Link to="/GetAQuotePage" className="text-sm text-muted-foreground transition-colors hover:text-primary font-default">
                  Schedule Your Visit
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default mb-6 text-lg font-semibold text-primary">Follow Our Work</h3>
            <div className="flex gap-3">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} data-index={i} className="flex size-10 items-center justify-center rounded-lg border border-primary/20 text-muted-foreground transition-all hover:border-primary/50 hover:bg-primary/10 hover:text-primary shadow-sm">
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <Separator className="my-8 bg-primary/10 lg:my-12" />

        {}
        <div className="flex flex-col items-center justify-between gap-4 text-sm text-muted-foreground md:flex-row">
          <p className="font-default">© {new Date().getFullYear()} {businessName}. Precision in every leaf.</p>
          <div className="flex items-center gap-6">
            <Link to="#" className="transition-colors hover:text-primary font-default">
              Privacy Policy
            </Link>
            <Link to="#" className="transition-colors hover:text-primary font-default">
              Service Terms
            </Link>
          </div>
        </div>
      </div>
    </section>;
}